import { v4 as uuidv4 } from 'uuid';

import getCookie from 'TMUtils/getCookie';
import getLastAttributionParams from 'TMUtils/getLastAttributionParams';
import setCookie from 'TMUtils/setCookie';

const applyCookieName = 'tmcoukApplicationJourneyId';

const useAnalytics = () => {
    const sendEvent = async (event) => {
        const appsflyerParams = getLastAttributionParams();

        const body = {
            event_type: event.eventType,
            ...(appsflyerParams && { ...appsflyerParams })
        };

        if (event.eventSource === 'applications') {
            let cookieUuid = getCookie(applyCookieName);

            if (!cookieUuid || cookieUuid === '') {
                cookieUuid = uuidv4();

                setCookie(
                    applyCookieName,
                    cookieUuid,
                    // allows cookie to be used on this domain and all subdomains
                    `.${window.location.hostname.replace('www.', '')}`,
                    // 30 minutes from now
                    new Date().getTime() + 60 * 30 * 1000
                );
            }

            body.web_journey_id = cookieUuid;
        }

        fetch(
            `${process.env.GATSBY_BASE_API_URL}/analytics/events/${event.eventSource}`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-correlation-id': uuidv4(),
                    'x-api-key': process.env.GATSBY_ANALYTICS_API_KEY
                },
                body: JSON.stringify(body)
            }
        );
    };

    return { sendEvent };
};

export default useAnalytics;
